import { render, staticRenderFns } from "./Jgjj.vue?vue&type=template&id=37ceae86&scoped=true&"
import script from "./Jgjj.vue?vue&type=script&lang=js&"
export * from "./Jgjj.vue?vue&type=script&lang=js&"
import style0 from "./Jgjj.vue?vue&type=style&index=0&id=37ceae86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ceae86",
  null
  
)

export default component.exports